import { render } from "./SetResidentRegistrationNumber.vue?vue&type=template&id=fbef26e2&scoped=true&ts=true"
import script from "./SetResidentRegistrationNumber.vue?vue&type=script&lang=ts"
export * from "./SetResidentRegistrationNumber.vue?vue&type=script&lang=ts"

import "./SetResidentRegistrationNumber.vue?vue&type=style&index=0&id=fbef26e2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbef26e2"]])

export default __exports__